import { finalize, catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { LoaderService } from '../services/loader.service';
import { CommonService } from '../services/common.service';

@Injectable()
export class InterceptedHttpService implements HttpInterceptor {
  constructor(private http: HttpClient, private loaderService: LoaderService, private commonService: CommonService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const authToken = this.commonService.getToken();
    const clonedRequest = req.clone({
      setHeaders: authToken ? { 'Auth-Token': authToken } : { Accept: 'application/json' }
    });

    this.loaderService.showPreloader();

    return next.handle(clonedRequest).pipe(
      finalize(() => this.loaderService.hidePreloader()),
      catchError((error) => {
        console.error('Error during request:', error);
        return throwError(() => new Error(error));
      })
    );
  }
}
